import { render, staticRenderFns } from "./vrdetail.vue?vue&type=template&id=f2645f4e&scoped=true&"
import script from "./vrdetail.vue?vue&type=script&lang=js&"
export * from "./vrdetail.vue?vue&type=script&lang=js&"
import style0 from "./vrdetail.vue?vue&type=style&index=0&id=f2645f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2645f4e",
  null
  
)

export default component.exports